import { LAB_REC_RECEIPTS_ITEM } from './lab-rec-receipts.js'
import { LAB_REC_NEWS_ITEM } from './lab-rec-news.js'
import { LAB_REC_SS_DEPOSIT_ITEM } from './lab-rec-ss-deposit.js'
import { LAB_REC_EMPLOYER_CONTRIB_ITEM } from './lab-rec-employer-contrib.js'

/** @type {import('../help-index.js').HelpScreen} */
export const LAB_REC_HELP = {
  screenId: 'lab-rec',
  label: 'Liquidación',
  navPath: 'Laboral → Liquidación',
  keywords: [
    'liquidación', 'recibo', 'sueldo', 'novedades', 'sac', 'aportes', 'contribuciones patronales',
    'cerrar recibo', 'imprimir recibo', 'f931', 'cargas sociales',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Flujo: novedades del período → liquidar recibos → revisar/ajustar → cerrar → imprimir. Incluye aportes patronales y datos del último depósito.',
  sidebarItems: [
    LAB_REC_RECEIPTS_ITEM,
    LAB_REC_NEWS_ITEM,
    LAB_REC_SS_DEPOSIT_ITEM,
    LAB_REC_EMPLOYER_CONTRIB_ITEM,
  ],
}
